import axios from 'axios';
import { DynamicContentComponent } from './dynamic-content.service.type';
import { DYNAMIC_CONTENT_SERVICE_ENDPOINTS } from './dynamic-content.service.config';

const axionsInstance = axios.create();

export class DynamicContentService {
  private readonly _endpoints: typeof DYNAMIC_CONTENT_SERVICE_ENDPOINTS;

  constructor() {
    this._endpoints = { ...DYNAMIC_CONTENT_SERVICE_ENDPOINTS };
  }

  public async getComponent(component: DynamicContentComponent, componentId: string) {
    return (await axionsInstance.get(this._endpoints.getDynamicContent(component, componentId))).data[0];
  }
}
